import { Flex, Text } from '@raystack/apsara';
import * as _ from 'lodash';

import { BinaryColorMap } from '@src/components/Colormaps/Assets/BinaryColorMap';
import { GnBuColorMap } from '@src/components/Colormaps/Assets/GnBuColorMap';
import { SpectralColorMap } from '@src/components/Colormaps/Assets/SpectralColormap';
import { YlGnBuColorMap } from '@src/components/Colormaps/Assets/YlGnBu';
import { YlOrRdColorMap } from '@src/components/Colormaps/Assets/YlOrRd';
import { BluesColorMap } from '@src/components/Colormaps/Assets/bluesColorMap';
import { cFastieColorMap } from '@src/components/Colormaps/Assets/cFastieColorMap';
import {
  JetColorMap,
  JetReverseColorMap
} from '@src/components/Colormaps/Assets/jetColorMap';
import { ndwiColorMap } from '@src/components/Colormaps/Assets/ndwiColormap';
import { PlasmaColorMap } from '@src/components/Colormaps/Assets/plasmaColorMap';
import { rPlumboColorMap } from '@src/components/Colormaps/Assets/rPlumboColorMap';
import { RdYlBuColorMap } from '@src/components/Colormaps/Assets/rdylbuColorMap';
import { rdylgnColormap } from '@src/components/Colormaps/Assets/rdylgnColormap';
import { schwarzwaldColorMap } from '@src/components/Colormaps/Assets/schwarzwaldColorMap';
import { TurboColorMap } from '@src/components/Colormaps/Assets/turbo';
import { viridisColorMap } from '@src/components/Colormaps/Assets/viridisColorMap';
import { YlGnColorMap } from '@src/components/Colormaps/Assets/ylgnColorMap';
import { For } from '@src/hoc';
import { rangeGenerator } from '@src/utils';
import { RIO_COLOR_STRINGS } from '@src/utils/constants/COLORMAP_CONSTANTS';

import styles from './styles.module.css';

/**'
 * @deprecated since change detection v3
 */
export const COLORMAP_FACTORY = {
  [`${RIO_COLOR_STRINGS.spectral}`]: SpectralColorMap,
  [`${RIO_COLOR_STRINGS.binary}`]: BinaryColorMap,
  [`${RIO_COLOR_STRINGS.BluesReverse}`]: BluesColorMap,
  [`${RIO_COLOR_STRINGS.cFastie}`]: cFastieColorMap,
  [`${RIO_COLOR_STRINGS.plasma}`]: PlasmaColorMap,
  [`${RIO_COLOR_STRINGS.RedYellowBlue}`]: RdYlBuColorMap,
  [`${RIO_COLOR_STRINGS.redYellowGreen}`]: rdylgnColormap,
  [`${RIO_COLOR_STRINGS.rPlumbo}`]: rPlumboColorMap,
  [`${RIO_COLOR_STRINGS.schwarzwald}`]: schwarzwaldColorMap,
  [`${RIO_COLOR_STRINGS.viridis}`]: viridisColorMap,
  [`${RIO_COLOR_STRINGS.YellowGreen}`]: YlGnColorMap,
  [`${RIO_COLOR_STRINGS.YellowOrangeRed}`]: YlOrRdColorMap,
  [`${RIO_COLOR_STRINGS.jet}`]: JetColorMap,
  [`${RIO_COLOR_STRINGS.jetReverse}`]: JetReverseColorMap,
  [`${RIO_COLOR_STRINGS.ndwi}`]: ndwiColorMap,
  [`${RIO_COLOR_STRINGS.yellowGreenBlue}`]: YlGnBuColorMap,
  [`${RIO_COLOR_STRINGS.turbo}`]: TurboColorMap,
  [`${RIO_COLOR_STRINGS.gnbu}`]: GnBuColorMap
};
/**
 *
 * This component will be moved out to a separate package
 */
export const ClassColorMap = ({ isRender, colorScale }) => {
  const buckets = colorScale.buckets;
  const title = colorScale.title;
  return isRender ? (
    <Flex className={styles.wrapper} gap='small' direction='column'>
      <Text size={3} weight={500} style={{ color: 'white' }}>
        {title}
      </Text>
      {Object.keys(buckets).map(bucketName => (
        <Flex key={bucketName} gap='small'>
          <div
            className={styles.color}
            style={{ backgroundColor: buckets[bucketName] }}
          />
          <Text size={1} style={{ color: 'white' }}>
            {bucketName}
          </Text>
        </Flex>
      ))}
    </Flex>
  ) : null;
};

export const RangeColorMap = ({ isRender, colorScale }) => {
  const rescale = colorScale.rescale || [];
  const colormap = colorScale.colormap;
  const logIntervals = colorScale?.logIntervals || [];

  if (rescale?.length === 0) return null;

  const range = isRender && rangeGenerator(rescale[0], rescale[1], 5);

  if (_.has(COLORMAP_FACTORY, colormap)) {
    const GradientFunction = COLORMAP_FACTORY[colormap];
    const colorGradientData = [...GradientFunction('range')];

    return isRender ? (
      <Flex
        className={styles.rangeWrapper}
        gap='extra-small'
        direction='column'
        align='start'
      >
        <div
          className={styles.rangeGradient}
          style={{
            background: `linear-gradient(to right, ${colorGradientData.join(
              ', '
            )})`
          }}
        />
        <Flex justify='between' align='stretch' className={styles.gradientText}>
          {logIntervals.length > 0 ? (
            <For each={logIntervals}>
              {(n, i) => (
                <Text
                  key={i}
                  style={{
                    color: 'var(--rs-color-foreground-base-secondary)'
                  }}
                  weight={400}
                  size={2}
                >
                  {n.toFixed(3)}
                </Text>
              )}
            </For>
          ) : (
            range &&
            range.map((n, i) => (
              <Text
                key={i}
                style={{
                  color: 'var(--rs-color-foreground-base-secondary)'
                }}
                weight={400}
                size={2}
              >
                {n.toFixed(3)}
              </Text>
            ))
          )}
        </Flex>
      </Flex>
    ) : null;
  }
};
